<template>
  <transition name="slide-fade" v-if="available || dimmed">
    <div class="form-section" :class="{dimmed: dimmed}">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Section",
  props: ["name", "status"],
  data: function() {
    return {};
  },
  computed: {
    available() {
      return this.status === "active";
    },
    dimmed() {
      return this.status === "done";
    }
  }
};
</script>

<style scoped>
.form-section {
  padding: 0 0 20px 0;
}
.dimmed {
  zoom: 1;
}

.greeting {
  margin: 40px 0 0 0;
  text-align: center;
}

.bubble {
  display: inline-block;
  background: #f6f6f6;
  /* box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.302),
    0 1px 3px 1px rgba(60, 64, 67, 0.149); */
  border: 0px solid #ddd;
  border-radius: 16px;
  padding: 10px 16px 8px 16px;
}

.wave {
  width: 26px;
  float: left;
  margin-top: -2px;
}

.text {
  display: inline-block;
  padding-left: 0.5em;
  font-size: 12pt;
  color: #222;
}
.strong {
  font-weight: 700;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(30px);
  opacity: 0;
}
</style>


